import actionTypes from '../constants/action-types';

const setErrorMessage = (message) => ({
  type: actionTypes.SET_ERROR_MESSAGE,
  payload: {
    message,
  },
});

export default setErrorMessage;
